import {NatGetUseFunctionMaster} from './NatGetUseFunctionMaster';
import Http from '../../../../network/Http'
import {NatGetValidUseFunctionLoggedIn} from './NatGetValidUseFunctionLoggedIn';

export default class NatUseFunctionMasterRepo {
    http: Http;

    constructor(http: Http) {
        this.http = http
    }

    // 利用機能マスタ一覧取得
    async getUseFunctionMaster(): Promise<NatGetUseFunctionMaster> {
        return await this.http.get(`/api/admin/useFunctionMaster`);
    }

    // 有効機能一覧取得（ログイン済）
    async getValidUseFunctionLoggedIn(): Promise<NatGetValidUseFunctionLoggedIn> {
        return await this.http.get(`/api/resident/useFunctionIds/valid/authed`);
    }
}
